import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';
import TransportPage from '../../views/TransportPage/';

class Vehicle extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			modyear : '',
			km : '',
			brand : '',
			model : '',
			color : '',
			vtype : '',
			driver : '',
			regno : '',
			engno : '',
			tyresize : '',
			inscomp : '',
			insno : '',
			insamt : '',
			renewalon : '',
			remarks : '',
			_message : '',
			alertClass :'',
			id : '',
		  _redirect : false,
		  posts: [],
		  drive : [],
		  activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	onClick(e){
		
		document.getElementById("vehform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('transport/deleteveh',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Vehicle Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Vehicle',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('transport/add',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Vehicle Added Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("vehform").reset();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
		
	}
	
	componentDidMount() {
		 
		this.getdata();
		this.getdriver();
	}
	
	/** get Driver **/
	getdriver(){
		
		GetData('employee/getdriver').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					drive : responseJson
				});
			}
		});
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('transport/getvehicle').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/transport/editvehicle/' + this.state.idd} />);

	}
	
	var dri = this.state.drive;
	
	 /** set type select box **/
	this.type = [
		{value : '', name : 'Select'},
		{value : 'Car', name : 'Car'},
		{value : 'Jeep', name : 'Jeep'},
		{value : 'Bus', name : 'Bus'},
		{value : 'Van', name : 'Van'},
		{value : 'Lorry', name : 'Lorry'},
		{value : 'Truck', name : 'Truck'},
		{value : 'Motor Cycle', name : 'Motor Cycle'}
	];
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
				  <Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '1' })}
					  onClick={() => { this.toggle('1'); }}
					>
					  Add Vehicle
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '2' })}
					  onClick={() => { this.toggle('2'); }}
					>
					  Vehicle List
					</NavLink>
				  </NavItem>
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
				  <TabPane tabId="1">
				  <Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="vehform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Add Vehicle</strong>
						</CardHeader>
						<CardBody>
						  <Row>
						   <Col md="12">
							<div className={this.state.alertClass}>
								{this.state._message}
							</div>
							<Row>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Model Year <span className="text-danger">*</span></Label>
								  <Input type="text" name="modyear" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Kilo Meter <span className="text-danger">*</span></Label>
								  <Input type="text" name="km" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Make (Brand) <span className="text-danger">*</span></Label>
								  <Input type="text" name="brand" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Model <span className="text-danger">*</span></Label>
								  <Input type="text" name="model" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Color <span className="text-danger">*</span></Label>
								  <Input type="text" name="color" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Type <span className="text-danger">*</span></Label>
								  <Input type="text" name="vtype" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Driver <span className="text-danger">*</span></Label>
								  <select name="driver" onChange={this.onChange} className="form-control" id="deprt"> 
									<option value="">Select Driver</option>
									{
										dri.map(function (item) {
											return <option value={item.id }>{item.empname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Registration no <span className="text-danger">*</span></Label>
								  <Input type="text" name="regno" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Engine No</Label>
								  <Input type="text" name="engno" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Tyre Size </Label>
								  <Input type="text" name="tyresize" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Company </Label>
								  <Input type="text" name="inscomp" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance No </Label>
								  <Input type="text" name="insno" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Amount </Label>
								  <Input type="text" name="insamt" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Insurance Renewal on <span className="text-danger">*</span></Label>
								  <Input type="date" name="renewalon" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Remarks </Label>
								  <Input type="textarea" name="remarks" onChange={this.onChange} rows="5" />
								</FormGroup>
							  </Col>
							</Row>
						  </Col>
						 </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  </Row>
				 </TabPane>
				 <TabPane tabId="2">
				   <Row>
					<Col md="12">
					  <Card>
						<CardHeader className="card-header-inner">
							<strong>Vehicle List</strong>
						</CardHeader>
						<CardBody>
						<Table responsive bordered>
							<thead>
								<tr>
									<th>S.No</th>
									<th>Vehicle No</th>
									<th>Barnd</th>
									<th>Model</th>
									<th>Driver</th>
									<th width="100">Manage</th>
								</tr>
							</thead>
							<tbody>
								{this.state.posts.map(item =>
								 
									<tr key = {item}>
										<td>{item.id}</td>
										<td>{item.regno}</td>
										<td>{item.brand}</td>
										<td>{item.model}</td>
										<td>{item.driver}</td>
										<td>
											<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
											&nbsp;&nbsp;
											<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
										</td>
									</tr>

								 )}
							</tbody>
						</Table>
						</CardBody>
					  </Card>
					</Col>
				   </Row>
				 </TabPane>
				 </TabContent>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Vehicle;


// WEBPACK FOOTER //
// ./src/transport/Vehicle/Vehicle.js